var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.747.129l-.62.623a.445.445 0 0 0 0 .624L5.717 7.01l-5.57 5.615a.445.445 0 0 0 0 .623l.619.624c.17.172.449.172.619 0l6.49-6.541A.438.438 0 0 0 8 7.01a.44.44 0 0 0-.126-.32L1.366.13a.436.436 0 0 0-.62-.001z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.7c0166a6ef0204cb1faee5b3788309d0.svg";
export { ForwardRef as ReactComponent };